import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { TwoWayBoundComponent } from '../base/two-way-bound.component';
import { DrI18nService } from '../../../core/services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { CKEditorComponent } from 'ckeditor4-angular';

@Component({
    selector: 'smp-ck-editor',
    templateUrl: './smp-ck-editor.component.html',
    styleUrls: ['./smp-ck-editor.component.scss']
})
export class SmpCkEditorComponent extends TwoWayBoundComponent<string>
                                  implements OnInit {
    @ViewChild('ckEditor', { static: true })
    public ckEditor: CKEditorComponent;

    @Input()
    public config?: any;

    public readonly editorUrl = `/assets/vendor/ckeditor/ckeditor.js`;

    public readonly defaultSmpConfig = {
        language: DrI18nService.getActiveLocaleInformation().shortName,
        allowedContent: true,
        entities: false,
        extraPlugins: 'dr-horizontal-separator',
        dialog_noConfirmCancel: true,
        toolbarGroups: [
            { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
            { name: 'editing', groups: [  'spellchecker' ] },
            { name: 'insert', groups: [ 'insert' ] },
            { name: 'styles', groups: [ 'styles' ] },
            '/',
            { name: 'paragraph', groups: [ 'list', 'indent', 'align' ] },
            { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
            { name: 'colors', groups: [ 'colors' ] }
        ],
        removeButtons: 'Flash,Smiley,Iframe,HorizontalRule,Format,Font,FontSize',
        startupShowBorders: false
    };

    constructor(protected drI18nService: DrI18nService, protected translateService: TranslateService) {
        super();
        this._idPrefix = 'smp-ck-editor.';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.config = Object.assign({}, this.defaultSmpConfig, this.config);
    }
}
